import React from 'react';

const frameStyle = {
  width: '100%',
  height: '100vh',
  display: 'block',
  border: 0,
  background: '#f5f7fb'
};

function HomePage() {
  return (
    <iframe
      src="/teacher-navigation.html?v=20260813-2"
      title="师友导航｜教师小喇叭"
      style={frameStyle}
    />
  );
}

export default HomePage;
